import { DEFAULT_TABLE_PAGE_SIZE } from "AppConstants";

/**
 * Framed data grids: a clear outer border, a tinted header row with a firmer rule beneath it, and
 * hairlines between rows. The header and body fills come from palette.DataGrid (base/colors.js).
 *
 * The grid derives its line colour from palette.divider lightened by 88%, which on the theme's
 * already-light divider all but vanishes; the token colours are set here instead. Selectors carry
 * .MuiDataGrid-root so they outrank the grid's own single-class variables rule.
 * @since NEXT_VERSION
 */
export default function dataGrid({ tokens }) {
  return {
    // Client-side grids open on 25 rows (DataGrid's own default is 100). A grid passing its own
    // initialState replaces this one, so those grids set the same page size themselves.
    defaultProps: {
      pageSizeOptions: [10, 25, 50, 100],
      initialState: { pagination: { paginationModel: { pageSize: DEFAULT_TABLE_PAGE_SIZE } } },
    },
    styleOverrides: {
      root: {
        "&.MuiDataGrid-root": {
          "--DataGrid-t-color-border-base": tokens.border,
          "--DataGrid-rowBorderColor": tokens.border,
          "--DataGrid-t-radius-base": "var(--radius)",
          "--unstable_DataGrid-radius": "var(--radius)",
          borderColor: tokens["border-strong"],
        },

        "& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader, & .MuiDataGrid-row--borderBottom .MuiDataGrid-filler, & .MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller":
          {
            borderBottomColor: tokens["border-strong"],
          },

        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 600,
          color: tokens["text-2"],
        },

        "& .MuiDataGrid-footerContainer": {
          borderTopColor: tokens["border-strong"],
        },
      },
    },
  };
}
